import { useEffect, useState } from "react";

const DEFAULT_TABLET_MIN = 768;
const DEFAULT_TABLET_MAX = 1025;

type WindowLike = {
  innerWidth: number;
  addEventListener: (type: string, listener: () => void) => void;
  removeEventListener: (type: string, listener: () => void) => void;
};

const getWindowLike = (): WindowLike | undefined => {
  const maybeGlobal = globalThis as { window?: unknown };
  const maybeWindow = maybeGlobal.window;
  if (!maybeWindow) return undefined;

  const candidate = maybeWindow as Partial<WindowLike>;
  if (
    typeof candidate.innerWidth !== "number" ||
    typeof candidate.addEventListener !== "function" ||
    typeof candidate.removeEventListener !== "function"
  ) {
    return undefined;
  }

  return candidate as WindowLike;
};

export const useIsTablet = (
  minWidth: number = DEFAULT_TABLET_MIN,
  maxWidth: number = DEFAULT_TABLET_MAX,
) => {
  const [isTablet, setIsTablet] = useState(() => {
    const win = getWindowLike();
    return win
      ? win.innerWidth >= minWidth && win.innerWidth < maxWidth
      : false;
  });

  useEffect(() => {
    const win = getWindowLike();
    if (!win) return;

    const handleResize = () => {
      setIsTablet(win.innerWidth >= minWidth && win.innerWidth < maxWidth);
    };

    win.addEventListener("resize", handleResize);
    return () => win.removeEventListener("resize", handleResize);
  }, [minWidth, maxWidth]);

  return isTablet;
};
